import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import {
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../General/General';
import { useNavigate } from "react-router-dom";
import CrudPageHeader from "../components/CrudPageHeader";
import DataTable from "../components/DataTable";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import CrudFormModal from "../components/CrudFormModal";

const ArticleCategory = () => {
    //#region const
    const navigate = useNavigate();
    const toaster = useToaster();
    const [ShowModal, setShowModal] = useState(false);
    const [Title, setTitle] = useState("");
    const [CategoryId, setCategoryId] = useState(General.GuidEmpty());
    const [Categories, setCategories] = useState([]);
    const [ShowDeleteModal, setShowDeleteModal] = useState(false);
    const [Order, setOrder] = useState(0);
    const [ErrorMsg, setErrorMsg] = useState("");
    //#endregion
    //#region method
    const clearDependecies = () => {
        setCategoryId(General.GuidEmpty());
        setTitle("");
        setOrder(0);
    }
    const Delete = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/articleCategory/delete/' + CategoryId,
            method: "delete",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setErrorMsg("");
                    toaster.push(General.ShowMessage('success', 'عملیات حذف با موفقیت انجام شد'), 'topCenter');
                    GetCategories();
                    setCategoryId(General.GuidEmpty());
                    setShowDeleteModal(false);
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetCategoryById = (Id) => {
        setCategoryId(Id);
        var RequestOption = {
            url: General.ApiRoot() + '/articleCategory/getById/' + Id,
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    const row = result.data && result.data[0];
                    if (row) {
                        setTitle(row.Title);
                        setOrder(row.Order);
                        setShowModal(true);
                    }
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetCategories = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/articleCategory/getAll',
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setCategories(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }

    const AddNewCategory = () => {
        setShowModal(true);
    }
    const CheckValidation = () => {
        if (Title == "") {
            setErrorMsg('لطفا عنوان را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا عنوان را وارد کنید'), 'topCenter');
            return false;
        }
        else {
            return true;
        }
    }
    const Save = () => {
        if (CheckValidation()) {
            setErrorMsg("");
            const isNew = CategoryId === General.GuidEmpty();
            const requestOptions = {
                url: General.ApiRoot() + '/articleCategory/' + (isNew ? 'add' : 'update'),
                method: "post",
                data: { Id: CategoryId, Title, Order },
                headers: {
                    'Content-Type': 'application/json',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(function (result) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفق انجام شد'), 'topCenter');
                        GetCategories();
                        clearDependecies();
                        setShowModal(false);
                    }).catch((error) => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    }
    //#endregion

    const columns = [
        {
            id: "title",
            header: () => <div className="text-right">عنوان دسته‌بندی</div>,
            cell: ({ row }) => <div className="">{row.original.Title}</div>,
        },
        {
            id: "order",
            header: () => <div className="text-right">ترتیب نمایش</div>,
            cell: ({ row }) => <div className="">{row.original.Order}</div>,
        },
        General.actionsColumn(GetCategoryById, (id) => (setCategoryId(id), setShowDeleteModal(true))),
    ];

    const table = useReactTable({
        data: Categories,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    useEffect(() => {
        if (!General.isLoggedIn()) {
            navigate('/');
        }
        else {
            GetCategories();
        }
    }, []);

    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <CrudPageHeader title="دسته‌بندی مقالات" onAdd={AddNewCategory} />
                <DataTable table={table} />
            </div>

            <CrudFormModal
                open={ShowModal}
                title="تعریف دسته‌بندی مقاله جدید"
                onClose={() => (setShowModal(false), clearDependecies())}
                onSave={Save}
            >
                <rsuite.Row>
                    <label>عنوان</label>
                    <rsuite.Input onChange={e => setTitle(e)} value={Title} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>ترتیب نمایش</label>
                    <rsuite.InputNumber value={Order} onChange={e => setOrder(e)} className="mt-1 mb-3" />
                </rsuite.Row>
            </CrudFormModal>

            <ConfirmDeleteModal
                open={ShowDeleteModal}
                message="آیا از حذف دسته‌بندی مطمئن هستید؟در صورت حذف قادر به بازیابی اطلاعات نخواهید بود."
                onConfirm={Delete}
                onCancel={() => (setShowDeleteModal(false), setCategoryId(General.GuidEmpty()))}
            />
        </SharedLayouts>
    )
}
export default ArticleCategory;
